import { render, staticRenderFns } from "./incidents-card.vue?vue&type=template&id=abd882c0&scoped=true"
import script from "./incidents-card.vue?vue&type=script&lang=js"
export * from "./incidents-card.vue?vue&type=script&lang=js"
import style0 from "./incidents-card.vue?vue&type=style&index=0&id=abd882c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd882c0",
  null
  
)

export default component.exports